module.exports = __webpack_public_path__ + "static/img/label-06.df33971.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/j_t/label-06.png
// module id = eJoB
// module chunks = 150